import React, { useState } from 'react';
import './Booking.css';

const Booking = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    gender: '',
    service: '',
    date: '',
    time: '',
    notes: ''
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const services = [
    'Hair Cut (Men)',
    'Hair Cut (Women)',
    'Hair Cut (Kids)',
    'Hair Styling',
    'Hair Straightening',
    'Hair Smoothening',
    'Hair Rebonding',
    'Hair Coloring',
    'Hair Spa',
    'Hair Highlights',
    'Beard Styling',
    'Shaving',
    'Cleanup',
    'Gold Facial',
    'Diamond Facial',
    'Bridal Facial',
    'Anti-Aging Facial',
    'Acne Treatment',
    'Skin Polishing',
    'Manicure',
    'Pedicure',
    'Waxing (Full Body)',
    'Waxing (Half Body)',
    'Threading',
    'Bleaching (Face)',
    'Bleaching (Full Body)',
    'Body Polishing',
    'Bridal Makeup',
    'Groom Makeup',
    'Pre-Wedding Package',
    'Party Makeup',
    'Engagement Makeup'
  ];

  const timeSlots = [
    '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
    '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM',
    '05:00 PM', '06:00 PM', '07:00 PM', '08:00 PM'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full name is required';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formData.phone.replace(/\D/g, ''))) {
      newErrors.phone = 'Please enter a valid 10-digit phone number';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.gender) {
      newErrors.gender = 'Please select gender';
    }

    if (!formData.service) {
      newErrors.service = 'Please select a service';
    }

    if (!formData.date) {
      newErrors.date = 'Please select a date';
    }

    if (!formData.time) {
      newErrors.time = 'Please select a time slot';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newErrors = validateForm();
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    console.log('Booking submitted:', formData);
    setSubmitted(true);
    
    setFormData({
      fullName: '',
      phone: '',
      email: '',
      gender: '',
      service: '',
      date: '',
      time: '',
      notes: ''
    });

    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };

  return (
    <div className="booking">
      <div className="booking-container">
        {/* <div className="booking-header">
          <h1>Book Your Appointment</h1>
          <p>Fill in the details below to schedule your visit</p>
        </div> */}

        {/* <form className="booking-form" onSubmit={handleSubmit}>
          {Object.keys(errors).length > 0 && (
            <div className="error-message">
              Please fill in all required fields correctly
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Full Name <span className="required">*</span></label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
              />
              {errors.fullName && <span className="error-message">{errors.fullName}</span>}
            </div>

            <div className="form-group">
              <label>Phone Number <span className="required">*</span></label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
              {errors.phone && <span className="error-message">{errors.phone}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email <span className="required">*</span></label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label>Gender <span className="required">*</span></label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
              {errors.gender && <span className="error-message">{errors.gender}</span>}
            </div>
          </div>

          <div className="form-group">
            <label>Select Service <span className="required">*</span></label>
            <select
              name="service"
              value={formData.service}
              onChange={handleChange}
            >
              <option value="">Choose a service</option>
              {services.map((service, index) => (
                <option key={index} value={service}>{service}</option>
              ))}
            </select>
            {errors.service && <span className="error-message">{errors.service}</span>}
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Preferred Date <span className="required">*</span></label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                min={new Date().toISOString().split('T')[0]}
              />
              {errors.date && <span className="error-message">{errors.date}</span>}
            </div>

            <div className="form-group">
              <label>Preferred Time <span className="required">*</span></label>
              <select
                name="time"
                value={formData.time}
                onChange={handleChange}
              >
                <option value="">Select time slot</option>
                {timeSlots.map((slot, index) => (
                  <option key={index} value={slot}>{slot}</option>
                ))}
              </select>
              {errors.time && <span className="error-message">{errors.time}</span>}
            </div>
          </div>

          <div className="form-group">
            <label>Additional Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Any special requests or requirements..."
            />
          </div>

          <button type="submit" className="submit-btn">
            Confirm Booking
          </button>

          {submitted && (
            <div className="success-message">
              ✓ Booking submitted successfully! We will contact you shortly to confirm your appointment.
            </div>
          )}
        </form> */}

        <div className="booking-info">
          <h3>Booking Information</h3>
          <ul className="info-list">
            <li><span className="info-icon">📞</span> Call us: +91 70864 53209</li>
            <li><span className="info-icon">💬</span> WhatsApp: +91 80111 10269</li>
            <li><span className="info-icon">🕒</span> Working Hours: Mon-Sun, 9:00 AM - 9:00 PM</li>
            <li><span className="info-icon">📍</span> 1st Floor, Medhi Building Tangra Satra Path, GS Road Rukmini Gaon</li>
            <li><span className="info-icon">⏰</span> Please arrive 10 minutes before your appointment</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Booking;
